import PropTypes from 'prop-types';

export function SquareWithRoundBordersShape({ fill, size }) {
  return (
    <rect
      x={size ? size - 8 : 0}
      y={3}
      fill={fill}
      strokeWidth={1}
      stroke="black"
      width={8}
      height={8}
      style={{ pointerEvents: 'none' }}
      rx={2}
      strokeOpacity={0.08}
    />
  );
}

SquareWithRoundBordersShape.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.number,
};
